import { render } from "./FilterProject.vue?vue&type=template&id=8004493e&scoped=true&ts=true"
import script from "./FilterProject.vue?vue&type=script&lang=ts"
export * from "./FilterProject.vue?vue&type=script&lang=ts"

import "./FilterProject.vue?vue&type=style&index=0&id=8004493e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8004493e"]])

export default __exports__